module.exports = __webpack_public_path__ + "img/data-effects.b86cdfe4.png";